export default __webpack_public_path__ + "static/media/pii1.2f1908be.svg";